/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/AvataxSandboxSummary.js
 */

import React from 'react';

const AvataxSandboxSummary = (data) => {
  return (
    <div className="DeliveryResultsSection">
      <div className="ResultItem">
        <div className="ResultLabel">Avatax Sandbox Account Id</div>
        <div className="ResultValue">{data.id}</div>
      </div>
      <div className="ResultItem">
        <div className="ResultLabel">Avatax Sandbox Account Status</div>
        <div className="ResultValue">
          {data.status ? data.status : 'Not available'}
        </div>
      </div>
    </div>
  );
};

export default AvataxSandboxSummary;
